export const SET_LOYALTY = 'SET_LOYALTY'
export const CREATE_LOYALTY = 'CREATE_LOYALTY'
export const EDIT_LOYALTY = 'EDIT_LOYALTY'
export const RESET_LOYALTY = 'RESET_LOYALTY'
export const REACTIVATE_LOYALTY = 'REACTIVATE_LOYALTY'
export const DEACTIVATE_LOYALTY = 'DEACTIVATE_LOYALTY'
export const INIT_LOYALTY_DATA = 'INIT_LOYALTY_DATA'



// WEBPACK FOOTER //
// ./app/actions/customers/loyalty/constants.js